import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { trigger, state, animate, transition, style } from '@angular/animations';

export const gray = trigger('gray', [
    state('true', style({
        'background': 'rgb(140, 140, 140)'
    })),
    transition('*=>*', animate('200ms'))
]);